import { useState, useEffect } from "react";
import Navbar from "./components/Navbar/navbar";
import Intro from "./components/Intro/intro";
import Experience from "./components/Experience/experience";
import Skills from "./components/Skills/skills";
import Works from "./components/Works/works";
import Contact from "./components/Contact/contact";
import Footer from "./components/Footer/footer";
import "./components/Intro/intro.css";

const ResumeModal = ({ onClose }) => (
  <div className="certOverlay" onClick={onClose}>
    <div className="certModal resumeModal" onClick={e => e.stopPropagation()}>
      <div className="certModalHeader">
        <span className="certModalTitle">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
          </svg>
          Resume — Avikal Singh
        </span>
        <div className="resumeModalActions">
          <a href="/resume.pdf" download="Avikal_Singh_Resume.pdf" className="resumeDownloadBtn">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
              <polyline points="7 10 12 15 17 10"/>
              <line x1="12" y1="15" x2="12" y2="3"/>
            </svg>
            Download
          </a>
          <button className="certModalClose" onClick={onClose} aria-label="Close">✕</button>
        </div>
      </div>
      <div className="resumeIframeWrap">
        <iframe src="/resume.pdf" title="Avikal Singh Resume" className="resumeIframe" />
      </div>
    </div>
  </div>
);

function App() {
  const [resumeOpen, setResumeOpen] = useState(false);

  useEffect(() => {
    const handleKey = (e) => { if (e.key === 'Escape') setResumeOpen(false); };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, []);

  return (
    <div className="App">
      {resumeOpen && <ResumeModal onClose={() => setResumeOpen(false)} />}
      <Navbar onOpenResume={() => setResumeOpen(true)} />
      <Intro />
      <Experience />
      <Skills />
      <Works />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;